// extracted by mini-css-extract-plugin
export default {"box":"News_box__cYC85","contentWrapper":"News_contentWrapper__c2Kch"};